import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';

import { EditorContext } from '../Editor/index';
import { updateEditorBrandColor } from 'actions/editor';

import { CustomPicker } from 'react-color';
import { colorToString } from 'components/Editor/helper/color';

import styles from './color.module.scss';

import { Button, Tabs, Tab } from 'react-bootstrap';
import GradientColorSettings from './gradientSettings';

const { Saturation, Hue, Alpha, EditableInput } = require('react-color/lib/components/common');

function CustomColorPicker(props) {
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [activeTab, setActiveTab] = useState('solid');

  const swatchColors = [
    'rgb(208, 2, 27, 1)',
    'rgb(245, 166, 35, 1)',
    'rgb(248, 231, 28, 1)',
    'rgb(139, 87, 42, 1)',
    'rgb(126, 211, 33, 1)',
    'rgb(65, 117, 5, 1)',
    'rgb(189, 16, 224, 1)',
    'rgb(144, 19, 254, 1)',
    'rgb(74, 144, 226, 1)',
    'rgb(80, 227, 194, 1)',
    'rgb(184, 233, 134, 1)',
    'rgb(0, 0, 0, 1)',
    'rgb(74, 74, 74, 1)',
    'rgb(155, 155, 155, 1)',
    'rgb(255, 255, 255, 1)',
  ]

  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;

  const brandColors = useSelector(state => { return _.get(state, `${editor}.present.brandTheme.colors`) || [] })

  const handleAddColors = () => {

    var selectedColor = {
      r: _.get(props.rgb, 'r'),
      g: _.get(props.rgb, 'g'),
      b: _.get(props.rgb, 'b'),
      a: _.get(props.rgb, 'a')
    }

    var colorRequest = [
      ...brandColors,
      selectedColor
    ]

    if (_.size(colorRequest) > 15) {
      colorRequest.shift();
    }

    dispatch(updateEditorBrandColor(editor, colorRequest))
  }

  useEffect(() => {
    if (props.type === 'gradient') {
      setActiveTab('gradient')
    }
  }, [])

  const handleDelete = (colorCode) => {
    var removedColor = _.filter(brandColors, (color) => {
      return color !== colorCode
    });

    dispatch(updateEditorBrandColor(editor, removedColor))
  }

  return (
    <Tabs
      activeKey={activeTab}
      defaultActiveKey='solid'
      className={styles.customEditTabs}
      onSelect={(tab) => setActiveTab(tab)}
      fill
    >
      <Tab className={styles.tabDetailForm} eventKey="solid" title='Solid Color'>
        <div className={styles.container}>
          <div className={styles.saturationBox}>
            <Saturation
              {...props}
              onChange={props.onChange}
            />
          </div>
          <div className={styles.colorSliderWrapper}>
            <div className={styles.sliderBox}>
              <div className={styles.hueSlider}>
                <Hue
                  hsl={props.hsl}
                  onChange={props.onChange}
                  direction={'horizontal'}
                />
              </div>
              <div className={styles.alphaSlider}>
                <Alpha {...props} direction={'horizontal'} />
              </div>
            </div>
            <div style={{ background: colorToString(props.rgb) }} className={styles.colorSwatch}></div>
          </div>
          <CustomInputFields {...props} />
          <div className={styles.brandColorSwatches}>
            <div className={styles.actionContainer}>
              <span className={styles.colorSwatchTitle}>Brand Colors</span>
              <span onClick={() => setEditMode(!editMode)} className={styles.actionButton}>{editMode ? "Done" : "Edit"}</span>
            </div>
            <div className={styles.colorSwatchWrapper}>
              <Button onClick={handleAddColors} disabled={editMode} className={styles.addButton} variant='info'>
                <i className={cx('cleverstory-plus', styles.addIcon)} />
              </Button>
              <ColorSwatchs colors={brandColors} editMode={editMode} onChange={props.onChange} handleDelete={handleDelete} />
            </div>
          </div>
          <div className={styles.gloablColorDisplay}>
            <span className={styles.colorSwatchTitle}>Global Colors</span>
            <div className={styles.colorSwatchWrapper}>
              <ColorSwatchs colors={swatchColors} onChange={props.onChange} />
            </div>
          </div>
          <div className={styles.buttonTray}>
            <Button onClick={() => props.onConfirm()} className={styles.save} >Apply</Button>
            <Button variant='secondary' onClick={() => props.onClose()} className={styles.save} >Cancel</Button>
          </div>
        </div>
      </Tab>
      {props.gradient &&
        <Tab className={styles.tabDetailForm} eventKey="gradient" title='Gradient'>
          <div className={styles.container}>
            <GradientColorSettings {...props} swatchColors={swatchColors} brandColors={brandColors} handleDelete={handleDelete} handleAddColors={handleAddColors} />
          </div>
        </Tab>}
    </Tabs>
  )
}

const ColorSwatchs = ({ colors, editMode, onChange, handleDelete }) => {
  return colors.map((color, index) => {
    return (
      <div key={index} className={cx(styles.colorBlock, { [styles.editMode]: editMode })}>
        <div
          onClick={() => {
            onChange(color)
          }}
          key={color}
          className={cx(styles.colorSwatcher)}
          style={{ background: _.isObject(color) ? colorToString(color) : color }}
        />
        {editMode &&
          <Button onClick={() => handleDelete(color)} variant='info' className={styles.deleteOverlay}>
            <i className={cx('cleverstory-close')} />
          </Button>
        }
      </div>
    );
  })
}

const CustomInputFields = (props) => {
  const inputStyles = {
    input: {
      width: '80%',
      fontSize: '11px'
    },
    label: {
      fontSize: '11px',
      color: '#000000',
    },
  };

  const handleHexColors = (colorCode) => {
    if (colorCode) {
      if (colorCode.includes('#')) {
        colorCode = colorCode.replace('#', '')
      }
      props.onChange(colorCode)
    }
  }

  const handleRgbaChange = (type, value) => {
    if (value) {
      var rgba = {
        ...props.color,
        [type]: value
      }
      props.onChange(rgba)
    }
  }

  return (
    <div className={styles.inputFieldsWrapper}>
      <div className={styles.hexCodeInput}>
        <EditableInput
          value={props.hex.replace('#', '')}
          onChange={handleHexColors}
          style={inputStyles}
        />
        <span style={inputStyles.label} >Hex</span>
      </div>
      <div className={styles.rgbaCodeInput}>
        <EditableInput
          value={_.get(props.rgb, 'r')}
          onChange={(value) => handleRgbaChange('r', value)}
          style={inputStyles}
        />
        <span style={inputStyles.label} >R</span>
      </div>
      <div className={styles.rgbaCodeInput}>
        <EditableInput
          value={_.get(props.rgb, 'g')}
          onChange={(value) => handleRgbaChange('g', value)}
          style={inputStyles}
        />
        <span style={inputStyles.label} >G</span>
      </div>
      <div className={styles.rgbaCodeInput}>
        <EditableInput
          value={_.get(props.rgb, 'b')}
          onChange={(value) => handleRgbaChange('b', value)}
          style={inputStyles}
        />
        <span style={inputStyles.label} >B</span>
      </div>
      <div className={styles.rgbaCodeInput}>
        <EditableInput
          value={_.get(props.rgb, 'a')}
          onChange={(value) => handleRgbaChange('a', value)}
          style={inputStyles}
        />
        <span style={inputStyles.label} >A</span>
      </div>
    </div>
  )
};

export default CustomPicker(CustomColorPicker);